import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {SignupPage} from '../signup/signup';
import {PasswordRecoveryPage} from '../password-recovery/password-recovery';
import {TabsControllerPage} from "../tabs-controller/tabs-controller";
import {WelcomePage} from "../welcome/welcome";

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }

  goToMyInfo(params) {
    if (!params) params = {};
    this.navCtrl.setRoot(TabsControllerPage);
  }

  goToSignup(params) {
    if (!params) params = {};
    this.navCtrl.setRoot(WelcomePage);
    this.navCtrl.push(SignupPage);
  }

  goToPasswordRecovery(params) {
    if (!params) params = {};
    this.navCtrl.push(PasswordRecoveryPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts